import { actionTypes } from './actions';

export const initialState = {
  isVisible: false,
  type: '',
};

const onboardingPopupReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_ONBOARDING_POPUP: {
      return {
        ...state,
        ...action.payload,
        isVisible: true,
      };
    }
    case actionTypes.HIDE_ONBOARDING_POPUP: {
      return {
        ...state,
        isVisible: false,
      };
    }

    default:
      return state;
  }
};

export default onboardingPopupReducer;
